export default function Services() {
  const services = [
    {
      icon: 'ri-brush-line',
      badge: 'CLEANING SERVICES',
      title: 'General Cleaning Services',
      items: ['Deep Cleaning', 'General Cleaning', 'Office Cleaning', 'Villa & Apartment Cleaning']
    },
    {
      icon: 'ri-bug-line',
      badge: 'SPECIALIZED SERVICES',
      title: 'Specialized Services',
      items: ['Pest Control', 'Loading & Unloading', 'Tower Glass Cleaning', 'Sofa & Carpet Shampooing']
    },
    {
      icon: 'ri-team-line',
      badge: 'STAFF DEPLOYMENT',
      title: 'Staff Deployment Services',
      items: ['General Workers & Helpers', 'Office Boy Service', 'Dedicated Cleaners', 'Experienced Team']
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start mb-16">
          <h2 className="text-5xl font-bold mb-6 md:mb-0">
            Our <span className="text-gray-800 font-serif italic">Services</span>
          </h2>
          <p className="text-gray-600 max-w-xl text-base leading-relaxed">
            We cater to small and big firms, as well as various departments of Bahrain Ministry, Factories, Malls and hospitals. Our services are available on a contract basis, so you can choose the duration that best suits your needs.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-32 h-32 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${service.icon} text-white text-5xl`}></i>
              </div>
              <div className="inline-block bg-teal-50 text-teal-600 px-4 py-1.5 rounded-full text-xs font-semibold mb-4">
                {service.badge}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <ul className="space-y-3 text-gray-600 mb-6 text-sm">
                {service.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <i className="ri-check-line text-teal-500 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <a 
                href="#contact" 
                className="text-teal-500 font-medium flex items-center gap-2 hover:gap-3 transition-all text-sm cursor-pointer"
              >
                Learn More <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
